import * as types from '../constants'
import _ from 'lodash'
const initState = {
  windowFocus: false
}

export default function(state = initState, action) {
    switch (action.type) {
        case types.SET_GLOBAL_VARIABLE:
          Object.keys(action.payload).forEach((key, i) => {
            state[key] = action.payload[key]
          });
        return _.cloneDeep(state)
        break;
        default:
        return state;
    }
}
